<template>
  <input v-model="search" placeholder="Zoek een collega">
</template>
<script>
export default {
  data() {
    return {
    }
  },
  computed: {
    search: {
      get () {
        return this.$store.state.search
      },
      set (value) {
        this.$store.commit('search', value)
      }
    }
  }
}
</script>
<style scoped>
</style>
